import { call, takeLatest } from "redux-saga/effects";
import * as documentApi from "../apis/documentsApi";
import { ADD_DOCUMENTS, ASSIGN_TEAM, ASSIGN_USER, DOCUMENTS_DELETE, DOCUMENTS_EDIT, DOCUMENTS_LIST, DOCUMENTS_VIEW, FOLDERS_LIST, GET_DOCUMENT_SUMMARY, TEAMS_DROP_DOWN, TRANSLATE_SUMMARY, UPLOAD_FILE, USERS_DROP_DOWN } from "../actions/types";

export function* addDocumentWorker(action) {
    try {
        const res = yield call(documentApi.addDocumentApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* documentListWorker(action) {
    try {
        const res = yield call(documentApi.documentListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadFileWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(documentApi.uploadFileApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* viewDocumentWorker(action) {
    try {
        const res = yield call(documentApi.documentViewApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteDocumentWorker(action) {
    try {
        const res = yield call(documentApi.documentDeleteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editDocumentWorker(action) {
    try {
        const res = yield call(documentApi.documentEditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* foldersDropDownWorker(action) {
    try {
        const res = yield call(documentApi.foldersDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* teamsDropDownWorker(action) {
    try {
        const res = yield call(documentApi.teamsDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* assignTeamWorker(action) {
    try {
        const res = yield call(documentApi.assignTeamApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* assignUserWorker(action) {
    try {
        const res = yield call(documentApi.assignUserApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* usersDropDownWorker(action) {
    try {
        const res = yield call(documentApi.usersDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* documentSummaryWorker(action) {
    try {
        const res = yield call(documentApi.documentSummaryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateSummaryWorker(action) {
    try {
        const res = yield call(documentApi.translateSummaryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/* Watcher Function*/

export function* addDocumentWatcher() {
    yield takeLatest(ADD_DOCUMENTS, addDocumentWorker);
}

export function* documentListWatcher() {
    yield takeLatest(DOCUMENTS_LIST, documentListWorker);
}

export function* uploadFileWatcher() {
    yield takeLatest(UPLOAD_FILE, uploadFileWorker);
}

export function* editdocumentWatcher() {
    yield takeLatest(DOCUMENTS_EDIT, editDocumentWorker);
}

export function* deletedocumentWatcher() {
    yield takeLatest(DOCUMENTS_DELETE, deleteDocumentWorker);
}

export function* viewdocumentWatcher() {
    yield takeLatest(DOCUMENTS_VIEW, viewDocumentWorker);
}

export function* foldersDropDownWatcher() {
    yield takeLatest(FOLDERS_LIST, foldersDropDownWorker)
}

export function* teamsDropDownWatcher() {
    yield takeLatest(TEAMS_DROP_DOWN, teamsDropDownWorker)
}

export function* assignTeamWatcher() {
    yield takeLatest(ASSIGN_TEAM, assignTeamWorker)
}

export function* assignUserWatcher() {
    yield takeLatest(ASSIGN_USER, assignUserWorker)
}

export function* usersDropDownWatcher() {
    yield takeLatest(USERS_DROP_DOWN, usersDropDownWorker)
}

export function* documentSummaryWatcher() {
    yield takeLatest(GET_DOCUMENT_SUMMARY, documentSummaryWorker)
}

export function* translateSummaryWatcher() {
    yield takeLatest(TRANSLATE_SUMMARY, translateSummaryWorker)
}